import { fetchGet, fetchPost, fetchPut } from './fetch';
import { AudioDetailRequest, GetDiscordInfoRequest, GetSubscriptionStatusResponse } from './interface';

const API_URL = '';

export const updateUserName = async (req: { name?: string; isFirstTime?: string }): Promise<GetSubscriptionStatusResponse> => {
  const url = `${API_URL}/api/v1/user/update_name`;
  return fetchPut<
    {
      name?: string;
      // isFirstTime?: string;
    },
    GetSubscriptionStatusResponse
  >(url, req);
};

export const getDiscordUserInfoByToken = async (req: { token?: string }): Promise<any> => {
  const url = `${API_URL}/api/v1/discord/info/:token`;
  return fetchGet<GetDiscordInfoRequest>(url, req, undefined);
};

export const bindDiscordAccount = async (req: { discordId?: string; userId?: string | null }): Promise<GetSubscriptionStatusResponse> => {
  const url = `${API_URL}/api/v1/discord/bind`;
  return fetchPut<
    {
      discordId?: string;
    },
    GetSubscriptionStatusResponse
  >(url, req);
};

export const bootstrap = async (): Promise<any> => {
  const url = `${API_URL}/api/auth/info`;
  return fetchGet<any>(url);
};

export const logout = async () => {
  const url = `${API_URL}/api/auth/logout`;
  return fetchGet<any>(url);
};
